import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, FileText, Users, Settings, Package, Database, TestTube, Bell } from 'lucide-react'
import { cn } from '@/lib/utils'

export default function Sidebar() {
  const location = useLocation()

  const menuItems = [
    {
      title: 'Dashboard',
      href: '/admin',
      icon: LayoutDashboard
    },
    {
      title: 'Prescriptions',
      href: '/admin/prescriptions',
      icon: FileText
    },
    {
      title: 'Users',
      href: '/admin/users',
      icon: Users
    },
    {
      title: 'Notifications',
      href: '/admin/notifications',
      icon: Bell
    },
    {
      title: 'Product Configuration',
      href: '/admin/products',
      icon: Package
    },
    {
      title: 'Database Management',
      href: '/admin/database',
      icon: Database
    },
    {
      title: 'Testing Tools',
      href: '/admin/test-tools',
      icon: TestTube
    },
    {
      title: 'Settings',
      href: '/admin/settings',
      icon: Settings
    }
  ]

  return (
    <div className="h-full py-6 px-4 overflow-y-auto">
      <nav className="space-y-1">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.href
          const Icon = item.icon
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex items-center gap-3 rounded-lg px-3 py-3 text-gray-500 transition-all hover:text-gray-900",
                "hover:bg-gray-50 text-sm md:text-base",
                isActive && "bg-blue-50 text-blue-600 hover:bg-blue-50 hover:text-blue-600"
              )}
            >
              <Icon className="h-5 w-5 flex-shrink-0" />
              <span className="truncate">{item.title}</span>
            </Link>
          )
        })}
      </nav>
    </div>
  )
}